import React from 'react'
import WithSuspense from "../../repeating-components/wrapper-components/with-suspense";
import Form from "react-bootstrap/Form";
import DatePicker from "react-datepicker";
import {uk} from "date-fns/locale";

import './modal-set-date.css';
import "react-datepicker/dist/react-datepicker.css";

import {useDispatch, useSelector} from "react-redux";
import {setParamsSetDateModal} from "../../../redux/modals/modal-set-date/actionSetDate";
const ModalBlackBackground = React.lazy(() => import('../../repeating-components/wrapper-components/modal-black-background'));

const ModalContentSetDate = ({sendForm}) => {
    const dispatch = useDispatch();

    const {phrases: {ak_au_ph_edit_end_date, save}, xenOptions: {options_day_rang}} = useSelector(state => state.lots);
    const {modalShow, newChosenDate} = useSelector(state => state.modalSetDate);

    const setParams = (data) => {
        dispatch(setParamsSetDateModal(data));
    }

    const handleShow = () => {
        setParams({modalShow: !modalShow});
    }

    const onChangeDate = (date) => {
        setParams({newChosenDate: date});
    }

    // Вычисляем минимальную и максимальную даты
    const getMinMaxDate = () => {
        const [minDays, maxDays] = options_day_rang.split('-').map(Number);
        const dayMs = 86400000;
        
        const now = new Date();
        const minDate = new Date(now.getTime() + minDays * dayMs);
        const maxDate = new Date(now.getTime() + maxDays * dayMs);
        
        return {minDate, maxDate};
    }

    const {minDate, maxDate} = getMinMaxDate();

    return (
        <WithSuspense>
            <ModalBlackBackground
                setShow={handleShow}
                show={modalShow}
                sendForm={sendForm}
                phraseTitle={ak_au_ph_edit_end_date}
                phraseSubmit={save}
            >
                <div className="p-4 d-flex justify-content-center">
                    <Form.Group className="col-md-5">
                        <DatePicker
                            customInput={
                                <Form.Control 
                                    required 
                                    size="sm" 
                                    className="text-center" 
                                    name="end_time"
                                    id="inputEndTime" 
                                    type="text"
                                />
                            }
                            onChange={onChangeDate}
                            locale={uk}
                            selected={newChosenDate || null}
                            dateFormat="dd.MM.yyyy"
                            maxDate={maxDate}
                            minDate={minDate}
                        />
                    </Form.Group>
                </div>
            </ModalBlackBackground>
        </WithSuspense>
    )
}

export default ModalContentSetDate